import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './ConditionalQuery.module.css'
import {
  Button,
  ConfigProvider,
  Divider,
  Flex,
  message,
  Select,
  Tooltip,
} from 'antd'
import classNames from 'classnames'
import userIcon from './userIcon.svg'
import shareImgIcon from './shareImg.svg'
export default function ConditionalQuery(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()
  
  // const incrementValue = Number(incrementAmount) || 0;

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            fontSize: 14,
          },
          Tabs: {
            colorPrimary: '#F5B544',
            itemHoverColor: '#F5B544',
            itemActiveColor: '#F5B544',
            itemSelectedColor: '#F5B544',
            horizontalItemGutter: 80,
          },
          Table: {
            colorPrimary: '#F5B544',
            headerBg: '#F5B544',
            rowHoverBg: '#fef8ed',
          },
        },
      }}
    >
      <div className={styles.background}>
        <div>
          <span style={{ marginLeft: 30 }}>学科</span>
          <Select
            style={{ marginLeft: 20 ,width: 120}}
            options={props.subjectList}
            value={props.subject}
            onChange={(value) => {
              props.setSubject(value)
            }}
          />
          <span style={{ marginLeft: 30 }}>年级</span>
          <Select
            style={{ marginLeft: 20, width: 100 }}
            options={props.gradeList}
            value={props.grade}
            onChange={(value) => {
              props.setGrade(value)
            }}
          />
        </div>
        <div>
          <Button
            type="default"
            style={{ marginRight: 20 }}
            onClick={() => {
              props.setSubject('')
              props.setGrade('')
            }}
          >
            重置
          </Button>
          <Button
            type="primary"
            style={{ marginRight: 30 }}
            onClick={() => {
              props.onSearch()
            }}
          >
            查询
          </Button>
        </div>
      </div>
    </ConfigProvider>
  )
}
